export default "__VITE_ASSET__DCof1sVY__"